import ar_XA from './markets/ar_XA';
import ar_XD from './markets/ar_XD';
import ar_XH from './markets/ar_XH';
import en_XA from './markets/en_XA';
import en_XD from './markets/en_XD';
import en_XH from './markets/en_XH';
import de_AQ from './markets/de_AQ';
import de_AT from './markets/de_AT';
import de_DE from './markets/de_DE';
import de_LU from './markets/de_LU';
import en_AQ from './markets/en_AQ';
import en_GB from './markets/en_GB';
import en_US from './markets/en_US';
import en_ZA from './markets/en_ZA';
import fr_BE from './markets/fr_BE';
import da_DK from './markets/da_DK';
import sv_SE from './markets/sv_SE';
import fr_LU from './markets/fr_LU';
import hu_HU from './markets/hu_HU';
import no_NO from './markets/no_NO';
import nl_BE from './markets/nl_BE';
import nl_NL from './markets/nl_NL';
import pl_PL from './markets/pl_PL';
import pt_PT from './markets/pt_PT';
import es_ES from './markets/es_ES';
import es_MX from './markets/es_MX';
import en_AU from './markets/en_AU';
import ro_RO from './markets/ro_RO';
import it_IT from './markets/it_IT';
import fr_FR from './markets/fr_FR';
import de_CH from './markets/de_CH';
import fr_CH from './markets/fr_CH';
import it_CH from './markets/it_CH';
import sk_SK from './markets/sk_SK';
import fr_CA from './markets/fr_CA';
import en_CA from './markets/en_CA';
import en_ID from './markets/en_ID';
import en_IN from './markets/en_IN';
import en_MY from './markets/en_MY';
import en_SG from './markets/en_SG';
import en_TH from './markets/en_TH';
import th_TH from './markets/th_TH';
import en_IE from './markets/en_IE';
import tr_TR from './markets/tr_TR';
import hr_HR from './markets/hr_HR';
import et_EE from './markets/et_EE';
import en_NZ from './markets/en_NZ';
import fi_FI from './markets/fi_FI';
import ru_RU from './markets/ru_RU';
import ja_JP from './markets/ja_JP';
import pt_BR from './markets/pt_BR';
import es_AR from './markets/es_AR';
import lt_LT from './markets/lt_LT';
import uk_UA from './markets/uk_UA';
import cs_CZ from './markets/cs_CZ';
import en_EG from './markets/en_EG';
import ar_EG from './markets/ar_EG';
import lv_LV from './markets/lv_LV';
import sl_SI from './markets/sl_SI';
import en_CY from './markets/en_CY';
import is_IS from './markets/is_IS';
import hr_BA from './markets/hr_BA';
import hr_RS from './markets/hr_RS';
import en_VN from './markets/en_VN';
import vi_VN from './markets/vi_VN';
import zh_TW from './markets/zh_TW';
import en_MT from './markets/en_MT';
import ko_KR from './markets/ko_KR';

export const translations = {
  ar_XA,
  ar_XD,
  ar_XH,
  en_XA,
  en_XD,
  en_XH,
  de_AQ,
  de_AT,
  de_DE,
  de_LU,
  en_AQ,
  en_GB,
  en_US,
  en_ZA,
  fr_BE,
  da_DK,
  sv_SE,
  fr_LU,
  hu_HU,
  no_NO,
  nl_BE,
  nl_NL,
  pl_PL,
  pt_PT,
  es_ES,
  es_MX,
  en_AU,
  en_NZ,
  ro_RO,
  it_IT,
  fr_FR,
  de_CH,
  fr_CH,
  it_CH,
  sk_SK,
  fr_CA,
  en_CA,
  en_ID,
  en_IN,
  en_MY,
  en_SG,
  en_TH,
  th_TH,
  en_IE,
  tr_TR,
  hr_HR,
  et_EE,
  fi_FI,
  ru_RU,
  ja_JP,
  pt_BR,
  es_AR,
  lt_LT,
  uk_UA,
  cs_CZ,
  en_EG,
  ar_EG,
  lv_LV,
  sl_SI,
  en_CY,
  is_IS,
  hr_BA,
  hr_RS,
  en_VN,
  vi_VN,
  zh_TW,
  en_MT,
  ko_KR,
};
